import { IReduxState } from 'types/redux';

export const devicesMapSelector = (state: IReduxState) => state.devices.map;
